module.exports = __webpack_public_path__ + "img/wulianwang (6).57863c49.png";